<!--
 * @Author: your name
 * @Date: 2020-11-03 10:25:34
 * @LastEditTime: 2022-12-21 13:38:26
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \heshan_web\src\views\wel\index.vue
-->
<template>
  <div>
      <el-table
      :data="tableData"
      style="width: 100%">
     
      <el-table-column
        prop="name"
        label="姓名"
        width="180">
      </el-table-column>
      <el-table-column
        prop="address"
        label="地址">
      </el-table-column>
       <el-table-column
      
        label="类型"
      >
       <template slot-scope="scope">
          <div>
            <span v-for="(item,i) in scope.row.type" :key="i">{{item.name}}、</span>
          </div>
      </template>
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
  import {mapGetters} from "vuex";

  export default {
    name: "wel",
    data() {
      return {
        activeNames: ['1', '2', '3', '5'],
        logActiveNames: ['18'],
        tableData:[
          { date: '2016-05-02',
            name: '来福士',
            address: '上海市普陀区金沙江路 1518 弄',
            type: [
              {id:1,name:'零件'},{id:2,name:'长期备货'},
            ]
          }
        ]
      };
    },
    // computed: {
    //   ...mapGetters(["userInfo"]),
    // },
    // methods: {
    //   handleChange(val) {
    //     window.console.log(val);
    //   }
    // },
  };
</script>

<style>
  .el-font-size {
    font-size: 14px;
  }
</style>

